import React from 'react';
import Layout from './Layout';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import { SentaiLogoImage, HidiveLogoImage } from '../../constants';

const LinkPage = ({ title, link }) => {



    return (
        <>
            <style dangerouslySetInnerHTML={{
                __html: `
            #gachapon { display: none !important; }
            `}} />
            <Layout>
                <h1 className="heading-1 pt-5"><span>{title}</span></h1>
                <Row className="text-center">
                    <Col xs={12} md={6} className="p-5">
                        <a href={`//www.sentaifilmworks.com/${link === "accessibility" ? "pages/" + link : link}`} target="_blank" rel="noopener noreferrer">
                            <Image className="logo-fluid" src={SentaiLogoImage} alt={`SentaiFilmWorks | ${title}`} />
                        </a>
                    </Col>
                    <Col xs={12} md={6} className="p-5">
                        <a className="" href={`//www.hidive.com/${link}`} target="_blank" rel="noopener noreferrer">
                            <Image className="logo-fluid" src={HidiveLogoImage} alt={`HIDIVE | ${title}`} />
                        </a>
                    </Col>
                </Row>
            </Layout>
        </>
    );
}

export default LinkPage;